import { connect } from "react-redux";
import CalculsFooterActions from "../components/CalculsFooterActions";
import "../components/Calculs.scss";
import { manageCalculsBulk } from "../actions";
import { bulkDownloadReports, bulkGenerateReports } from "../../fdes/actions";

export default connect(
  (state) => ({}),
  (dispatch) => ({
    manageCalculsBulk: (action, calculIds, folderId) => {
      dispatch(manageCalculsBulk(action, calculIds, folderId));
    },
    bulkGenerateReports: (calculs, folderId) => {
      dispatch(bulkGenerateReports(calculs, folderId));
    },
    bulkDownloadReports: (calculIds, types, folderId) => {
      dispatch(bulkDownloadReports(calculIds, types, folderId));
    },
  }),
)(CalculsFooterActions);
